// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--oVBKe","item":"item--Z2AnK"};